import type { FC } from 'react';

export type UserAvatarName = {
  FirstName?: string | null;
  LastName?: string | null;
};

type CardUserAvatarProps = {
  userName: UserAvatarName;
};

const UserAvatar: FC<CardUserAvatarProps> = ({ userName }) => (
  <div
    className={
      'bg-teal text-navy text-sm flex items-center justify-center w-[30px] min-w-[30px] h-[30px] rounded-full'
    }
  >
    <span>{`${userName.FirstName?.charAt(0).toUpperCase()}${userName.LastName?.charAt(0).toUpperCase()}`}</span>
  </div>
);

export default UserAvatar;
